import React, { FC } from 'react'
import { SelectProps } from '@mui/material'
import { makeStyles } from '@mui/styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = makeStyles({
  arrow: {
    color: '#FFFFFF',
    opacity: '60%',
  },
})

export const SelectArrow: FC = (props: SelectProps) => {
  const { arrow } = useStyles()

  return <ExpandMoreIcon className={`${arrow} + ${props.className}`} />
}
